import { BookOpen, Heart, Mic, Quote, Sparkles } from "lucide-react";

const Tile = ({ className = "", delay = 0, children, testid }) => (
  <div className={`lp-rise rounded-xl border border-[#D4AF37]/15 bg-[#09090B]/60 p-3.5 backdrop-blur-md ${className}`} style={{ animationDelay: `${delay}ms` }} data-testid={testid}>{children}</div>
);

const Label = ({ icon: Icon, children }) => (
  <div className="mb-2 flex items-center gap-1.5 text-[9px] font-semibold uppercase tracking-[0.2em] text-[#D4AF37]"><Icon className="h-3 w-3" />{children}</div>
);

const MOOD = [3, 4, 3, 4, 5];
const WAVE = [5, 9, 14, 8, 16, 11, 6, 13, 9, 15, 7, 11, 5, 10, 14, 8];

export const WellbeingPreview = () => (
  <div className="lp-float relative mt-6" style={{ animationDelay: "-3s" }} data-testid="login-wellbeing-preview">
    <div className="relative overflow-hidden rounded-2xl border border-[#D4AF37]/25 bg-[#121214]/90 p-3 shadow-[0_20px_50px_rgba(0,0,0,0.6)]">
      <div className="mb-3 flex items-center justify-between px-1">
        <span className="font-wb text-sm text-zinc-100">Good morning, Alex</span>
        <span className="flex items-center gap-1 rounded-full bg-[#D4AF37] px-2 py-0.5 text-[10px] font-semibold text-[#09090B]"><Heart className="h-3 w-3" fill="currentColor" />Checked in</span>
      </div>
      <div className="grid grid-cols-2 gap-2.5">
        <Tile className="border-[#D4AF37]/40 bg-gradient-to-br from-[#33290D] to-[#1a1508] col-span-2" delay={300} testid="wbp-message">
          <Label icon={Sparkles}>A message for you</Label>
          <p className="font-wb text-[15px] leading-snug text-zinc-100">Three interviews this month is momentum, not luck. Your persistence is working.</p>
        </Tile>
        <Tile className="col-span-2 sm:col-span-1" delay={420} testid="wbp-wisdom">
          <div className="mb-2 flex items-center justify-between gap-2">
            <Label icon={Quote}>Today's wisdom</Label>
            <span className="mb-2 shrink-0 rounded-full border border-[#D4AF37]/50 px-1.5 py-px text-[8px] font-semibold tracking-[0.15em] text-[#F3C649]">VERIFIED QUOTE</span>
          </div>
          <p className="font-wb text-[13px] italic leading-snug text-zinc-200">“You have power over your mind, not outside events.”</p>
          <p className="mt-1.5 text-[10px] text-zinc-500">— Marcus Aurelius, Meditations</p>
        </Tile>
        <Tile delay={540} testid="wbp-checkin">
          <Label icon={Heart}>This week</Label>
          <div className="flex h-12 items-end gap-1.5">
            {MOOD.map((m, i) => <span key={i} className="lp-grow flex-1 rounded-t bg-gradient-to-t from-[#D4AF37]/40 to-[#F3C649]" style={{ height: `${m * 20}%`, animationDelay: `${700 + i * 90}ms` }} />)}
          </div>
          <p className="mt-2 text-[10px] text-zinc-400">Energy up <span className="font-semibold text-[#F3C649]">+18%</span> since last week</p>
        </Tile>
        <Tile delay={660} testid="wbp-journey">
          <Label icon={BookOpen}>Wisdom Journey</Label>
          <p className="text-xs font-medium text-zinc-100">Becoming Resilient</p>
          <div className="mt-2 flex gap-1">{[1, 2, 3, 4, 5].map((d) => <span key={d} className={`h-1.5 flex-1 rounded-full ${d <= 3 ? "bg-[#D4AF37]" : "bg-[#27272A]"}`} />)}</div>
          <p className="mt-1.5 text-[10px] text-zinc-500">Day 3 of 5 · at your own pace</p>
        </Tile>
        <Tile className="col-span-2 sm:col-span-1" delay={780} testid="wbp-companion">
          <Label icon={Mic}>Career Companion</Label>
          <div className="flex items-center gap-2.5">
            <span className="relative flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#D4AF37] text-[#09090B]">
              <span className="absolute inset-0 animate-ping rounded-full bg-[#D4AF37]/40" /><Mic className="relative h-4 w-4" />
            </span>
            <div className="flex h-6 flex-1 items-center gap-[3px] overflow-hidden">
              {WAVE.map((h, i) => <span key={i} className="lp-wave w-[3px] shrink-0 rounded-full bg-[#F3C649]/80" style={{ height: `${h}px`, animationDelay: `${i * 80}ms` }} />)}
            </div>
          </div>
          <p className="mt-2 text-[10px] text-zinc-500">“Help me rebuild my confidence.”</p>
        </Tile>
      </div>
    </div>
  </div>
);
